import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { PALETTE_PRESET_COLOR_ORDER } from '../constants/color-schemes';

const { PresetContainer, ColorPalette } = designSystem;

function ColorPalettePreset({
  id,
  title,
  editLabel = '',
  deleteLabel = '',
  isSelected = false,
  isCustom = false,
  colors,
  onClick,
  onEditClick,
  onDeleteClick,
}) {
  const handleClick = () => onClick(id);
  const handleEditClick = () => onEditClick(id);
  const handleDeleteClick = () => onDeleteClick(id);

  return (
    <PresetContainer
      title={title}
      editLabel={editLabel}
      isSelected={isSelected}
      onClick={handleClick}
      onEditClick={handleEditClick}
      {...(isCustom && {
        deleteLabel,
        onDeleteClick: handleDeleteClick,
      })}
    >
      <ColorPalette colors={PALETTE_PRESET_COLOR_ORDER.map((key) => colors[key])} />
    </PresetContainer>
  );
}

ColorPalettePreset.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  editLabel: PropTypes.string,
  deleteLabel: PropTypes.string,
  isSelected: PropTypes.bool,
  isCustom: PropTypes.bool,
  colors: PropTypes.shape({
    'ws-light-0': PropTypes.string.isRequired,
    'ws-light-1': PropTypes.string.isRequired,
    'ws-dark-0': PropTypes.string.isRequired,
    'ws-dark-1': PropTypes.string.isRequired,
    'ws-primary-0': PropTypes.string.isRequired,
    'ws-secondary-0': PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
};

export default ColorPalettePreset;
